const editor = {
  documents: "Documents",
  documentsCount: "documents",
  newDocument: "New Document",
  searchDocuments: "Search documents...",
  templates: "Templates",
  saveAsTemplate: "Save as Template",
  export: "Export",
  import: "Import",
  copyAsMarkdown: "Copy as Markdown",
  share: "Share",
  shareDescription: "Create a read-only link to share this document",
  createShareLink: "Create Share Link",
  copyLink: "Copy Link",
  revokeLink: "Revoke Link",
  versionHistory: "Version History",
  noVersions: "No versions saved yet",
  restore: "Restore",
  duplicate: "Duplicate",
  delete: "Delete",
  autoSaved: "Auto-saved",
  confirmDeleteDoc: "Delete this document?",
  confirmDeleteDocMessage: "This action cannot be undone. All versions and share links will be removed.",
  editTemplate: "Edit Template",
  deleteTemplate: "Delete Template",
  confirmDeleteTemplate: "Delete this template?",
  confirmDeleteTemplateMessage: "This template will be permanently deleted.",
  templateDeleted: "Template deleted",
  templateUpdated: "Template updated",
  words: "words",
  chars: "chars",
  minRead: "min read",
  lastSaved: "Last saved",
  shareExpiry: "Link expiry",
  noExpiry: "No expiry",
  expires24h: "24 hours",
  expires7d: "7 days",
  expires30d: "30 days",
  linkExpired: "This link has expired",
  sourceBannerStoryMap: "Story Map",
  sourceBannerBack: "Back to Story Map",
  breadcrumbStoryMap: "Story Map",
  sourceBannerBookmark: "Bookmark",
  sourceBannerOpenUrl: "Open URL",
  loadingDocuments: "Loading documents...",
  noDocumentsYet: "No documents yet",
  untitled: "Untitled",
  saving: "Saving...",
  saved: "Saved",
  retrying: "Retrying...",
  saveError: "Save error",
  conflictMessage: "Document updated in another tab",
  reload: "Reload",
  offlineSavedLocally: "Offline — saved locally",
  menu: "menu",
  placeholderSlashMenu: "Type / for block menu...",
  placeholderHeading1: "Main heading",
  placeholderHeading2: "Subheading",
  placeholderHeading3: "Small heading",
  placeholderHeading: "Heading",
  placeholderListItem: "List item",
  placeholderTask: "Task",
  placeholderBlockquote: "Quote...",
  placeholderCode: "// Write code here...",
  placeholderToggle: "Toggle heading...",
  placeholderCallout: "Write here...",
  timeJustNow: "just now",
  timeSecondsAgo: "{{n}}s ago",
  timeMinutesAgo: "{{n}}m ago",
  timeHoursAgo: "{{n}}h ago",
  categoryManagement: "Management",
  categoryDevelopment: "Development",
  categoryStrategy: "Strategy",
  categoryGeneral: "General",
} as const;
export default editor;
